(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call', {
            parent: 'entity',
            /*
            url: '/phone-call?page&sort&search',
            */
            url: '/phone-call?page&sort&search&searchType&startDate&endDate&insignificantFilter&inCallsHideFilter&outCallsHideFilter&missedCallsHideFilter&uncheckedOnlyFilter&repeatedCallsFilter&divisionId',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCall.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call/phone-calls.html',
                    controller: 'PhoneCallController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'callTime,desc',
                    squash: true
                },
                /*
                search: null
                */
                search: null,
                searchType: {
                    value: 'all',
                    squash: true
                },
                divisionId: {
                    value: null,
                    squash: true
                },
                startDate: null,
                endDate: null,
                inCallsHideFilter: {
                    value: 'false',
                    squash: true
                },
                outCallsHideFilter: {
                    value: 'false',
                    squash: true
                },
                missedCallsHideFilter: {
                    value: 'false',
                    squash: true
                },
                insignificantFilter: {
                    value: 'true',
                    squash: true
                },
                uncheckedOnlyFilter: {
                    value: 'false',
                    squash: true
                },
                repeatedCallsFilter: {
                    value: 'true',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        /*
                        search: $stateParams.search
                        */
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        inCallsHideFilter: $stateParams.inCallsHideFilter,
                        outCallsHideFilter: $stateParams.outCallsHideFilter,
                        missedCallsHideFilter: $stateParams.missedCallsHideFilter,
                        insignificantFilter: $stateParams.insignificantFilter,
                        uncheckedOnlyFilter: $stateParams.uncheckedOnlyFilter,
                        repeatedCallsFilter: $stateParams.repeatedCallsFilter,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCall');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    $translatePartialLoader.addPart('reports');
                    return $translate.refresh();
                }]
            },
            onEnter: ['PhoneCallCheckTrackerService', 'Principal', function(PhoneCallCheckTrackerService, Principal) {
                if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
                    PhoneCallCheckTrackerService.subscribe();
                }
            }],
            onExit: ['PhoneCallCheckTrackerService', 'Principal', function(PhoneCallCheckTrackerService, Principal) {
                if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
                    PhoneCallCheckTrackerService.cleanListener();
                }
            }]
        })
        .state('phone-call-detail', {
            parent: 'phone-call',
            url: '/phone-call/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCall.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call/phone-call-detail.html',
                    controller: 'PhoneCallDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCall');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCall', function($stateParams, PhoneCall) {
                    return PhoneCall.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-detail.edit', {
            parent: 'phone-call-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-dialog.html',
                    controller: 'PhoneCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCall', function(PhoneCall) {
                            return PhoneCall.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call.new', {
            parent: 'phone-call',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_NO_SUCH_ROLE'] // никто не должен создавать запись с формы
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-dialog.html',
                    controller: 'PhoneCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                callId: null,
                                callTime: null,
                                callingNumber: null,
                                user: null,
                                calledNumber: null,
                                callingCaption: null,
                                calledCaption: null,
                                waitDuration: null,
                                realWaitDuration: null,
                                talkDuration: null,
                                recordURL: null,
                                modifierCaption: null,
                                createTime: null,
                                notFinal: false,
                                sequenceCallId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: 'phone-call' });
                }, function() {
                    $state.go('phone-call');
                });
            }]
        })
        .state('phone-call.edit', {
            parent: 'phone-call',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-dialog.html',
                    controller: 'PhoneCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCall', function(PhoneCall) {
                            return PhoneCall.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: 'phone-call' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call.delete', {
            parent: 'phone-call',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-delete-dialog.html',
                    controller: 'PhoneCallDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCall', function(PhoneCall) {
                            return PhoneCall.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: 'phone-call' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
